$(function() {

  /**
   * エラー項目が入力されたらエラー表示をしない。
   */
  var formSelectError = (function() {
    var className = 'sw-FormSelect-Error';
    var select = (function() {
      $('.' + className + ' select').on('change', function() {
        if($(this).val() !== '') {
          $(this).closest('.sw-FormSelect').removeClass(className);
        } else {
          $(this).closest('.sw-FormSelect').addClass(className);
        }
      });
    })();
  })();

}());
